/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useEffect, useState } from "react";
import * as API from "../../http/api";
import { useHistory } from "react-router-dom";
import { closelightbox } from "../../util/Functions";
import { Grid, TextField, Button, DialogActions, DialogContent, Dialog, DialogTitle, IconButton, MenuItem } from "@mui/material";
import { ModalStyle } from "../../util/Styles";
import { Close } from "@mui/icons-material";

const ChangeRol = (props) => {
  const [zPos, setZPos] = useState(45);
  const history = useHistory();
  const [content, setContent] = useState({});
  const [roles, setRoles] = useState([]);
  const [form, setForm] = useState({
    agentUuid: "",
    idRol: [""],
  });
  const [disabled, setDisabled] = useState(true);
  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    props.changeLoader(true);
    setZPos(10);

    setContent(props.contentModal);
    let session = JSON.parse(localStorage.session);
    let all = await API.service( "getAllRoles", { uuid: session["uuid"] }, props.pos, props.changeAlert, props.changeLoader, history);
    if (all.data.data.response == "OK") {
      let config = localStorage.config ? JSON.parse(localStorage.config) : {};
      let roles = all.data.data.roles
      let allowRoles = roles?.filter((r) => {
        if(config.allowRoles.includes(r.uuid)){
          return r
        }
      }).sort((a, b) => a.name > b.name ? 1 : -1)

      setRoles(JSON.parse(JSON.stringify(allowRoles)));

      let rol = config["idRol"];
      let f = form;
      f.idRol = [rol];
      setForm(JSON.parse(JSON.stringify(f)));
    }
    props.changeLoader(false);
    setZPos(45);
  };

  const change = (e) => {
    let f = form;
    f.idRol[0] = e.target.value;
    setForm(JSON.parse(JSON.stringify(f)));
    if (e.target.value) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  const updateRol = async () => {
    props.changeLoader(true);
    setZPos(10);

    let f = form;
    f.agentUuid = JSON.parse(localStorage.session)["uuid"];
    let request = await API.service( "free", f, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status === 200) {
      if (request.data.data.response == "OK") {
        let s = JSON.parse(localStorage.session);
        s["menuItems"] = request.data.data.content.menu;
        s["rol"] = [request.data.data.content.idRol];
        s["roleName"] = request.data.data.content.nombre;
        delete s["secondaryMenu"];

        if (request.data.data.content.secondaryMenu) {
          s["secondaryMenu"] = request.data.data.content.secondaryMenu;
        }
        
        localStorage.session = JSON.stringify(s);
        window.location.reload();
      }
    }
  };

  return (
    <Dialog open={true} sx={{zIndex: zPos, filter: zPos !== 45 ? 'blur(2px)': "none" }} fullWidth>
      <ModalStyle property={String(disabled)}>
        <DialogTitle style={{marginBottom: "0"}} >
          {content["title"]} <p id="subtitle">{JSON.parse(localStorage.session)["roleName"]}</p>
          <IconButton id="headButton" onClick={closelightbox}><Close/></IconButton>
        </DialogTitle>

        <DialogContent>
          <Grid container spacing={2} sx={{ marginTop: "10px" }}>
            <Grid item xs={12}>
              <TextField  
                label="Rol" value={form.idRol[0]} select onChange={change.bind(this)} size="small" fullWidth >
                {roles?.map((item, index) => (
                  <MenuItem key={`option-rol-${index}`} value={item.uuid}>{item.name}</MenuItem>
                ))}
              </TextField>              
            </Grid>          
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button id='buttonCancel' variant="outlined" onClick={closelightbox} >Cancelar</Button>
          <Button disabled={disabled} variant="contained" onClick={updateRol.bind(this)} >Cambiar rol</Button>
        </DialogActions>
      </ModalStyle>
    </Dialog>     
  );
};

export default ChangeRol;
